import React from "react";
import "./Title.css";

const Title = props => <h1 className="title">{props.children}</h1>;

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title/Title.js